export default "__VITE_ASSET__CBa3Z0jq__"